import React, { useCallback } from 'react';
import { AsyncConnectModal } from '@atlassian/jira-connect-issue-modal/src/async.tsx';
import type { OnErrorCallback } from '@atlassian/jira-issue-shared-types/src/common/types/error-type.tsx';
import type { IssueKey } from '@atlassian/jira-shared-types/src/general.tsx';
import { useNavigationEffect } from '../../controllers/on-navigation-change/index.tsx';
import type { ModalProps } from '../../types.tsx';

export type ConnectIssueModalOptions = {
	issueKey: IssueKey;
	onError: OnErrorCallback;
	onCancel: (issueKey: IssueKey | null | undefined, forceRefresh?: boolean) => void;
};

export type Props = ConnectIssueModalOptions & ModalProps;

const ConnectIssueModal = ({ issueKey, onClose, onCancel, onError }: Props) => {
	const onCloseCallback = useCallback<ConnectIssueModalOptions['onCancel']>(
		(props) => {
			onClose();
			// onCancel might not be defined
			// onCancel might throw an error
			onCancel?.(props);
		},
		[onCancel, onClose],
	);

	useNavigationEffect(() => {
		// execute in timeout in order to not let error from onCancel trigger ErrorBoundary
		setTimeout(() => onCloseCallback(issueKey));
	});

	return <AsyncConnectModal issueKey={issueKey} onClose={onCloseCallback} onError={onError} />;
};

export default ConnectIssueModal;
